import { duration } from 'moment';
import {msToHours} from '../Common/Util_methods/format';
import {orderBy} from "lodash";

class FormatAlarms{
    static durationInHours(alarmData:any){
        if (alarmData.length === 0) return []
        let arr:any = []
        alarmData.forEach(obj=>{
            const copy = {...obj}
            copy.duration = msToHours(obj.duration)
            if(copy.durationPerShiftHours){
                copy.durationPerShiftHours = msToHours(obj.durationPerShiftHours)
            }
            if (copy.failureDuration){
                copy.failureDuration = msToHours(obj.failureDuration)
            }
            if(copy.failureTimeoutDuration){
                copy.failureTimeoutDuration = msToHours(obj.failureTimeoutDuration)
            }
            if (copy.idleAfterFailureDuration){
                copy.idleAfterFailureDuration = msToHours(obj.idleAfterFailureDuration)
            }
            if(copy.idleAfterRunningDuration){
                copy.idleAfterRunningDuration = msToHours(obj.idleAfterRunningDuration)
            }
            if(copy.runningDuration){
                copy.runningDuration = msToHours(obj.runningDuration)
            }
            if(copy.shiftDuration){
                copy.shiftDuration = msToHours(obj.shiftDuration)
            }
            arr.push(copy)
        })
        return arr
    }
    static customerNames(devices:any,alarmData:any){
        let arr:any = []
        alarmData.forEach(obj=>{
            const copy = {...obj}
            const device = devices.find((devObj)=> devObj.customerID === obj.text)
            
            copy.text = device.customerName
            arr.push(copy)
        })
        return arr;
    }
    static alarmTexts(alarmData){
        let arr  = []
        alarmData.forEach(obj=>arr.push(obj.text));
        return arr;
    }

    static sortAlarmsBy(key:string, alarmData,direction:any){
        return orderBy(alarmData,[key],[direction])
    }

}

export default FormatAlarms;